import { DotLegalSearchField } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/system";
import { useTranslation } from "../localization/useTranslation";
import { useDataProcessorRecordStyles } from "../processingActivityRecord/dataProcessorRecord/DataProcessorRecord.styles";
import { DataProcessorRecordTableModel } from "../processingActivityRecord/dataProcessorRecord/DataProcessorRecord.types";
import DataProcessorRecordGroups from "../processingActivityRecord/dataProcessorRecord/DataProcessorRecordGroups";

export interface IDataProcessorRecord {
    groups: Array<DataProcessorRecordTableModel>;
    isLoading: boolean;
    searchString: string;
    setSearchString: (s: string) => void;
}

function DataProcessorRecord(props: IDataProcessorRecord) {
    const { translateString } = useTranslation();
    const styles = useDataProcessorRecordStyles();

    return (
        <Box>
            {props.groups.length > 0 && (
                <Box sx={styles.searchField}>
                    <DotLegalSearchField labelSearch={translateString("search")} value={props.searchString} onChange={(e) => props.setSearchString(e)} />
                </Box>
            )}

            <DataProcessorRecordGroups groups={props.groups} isLoading={props.isLoading} />
        </Box>
    );
}

export default DataProcessorRecord;
